import { api } from 'services/api';
import { ListResponse } from 'types/list-response';
import { Project } from 'types/project';

const getProjects = api.injectEndpoints({
    endpoints: builder => ({
        getProjects: builder.query<Response, Request>({
            query: params => ({
                method: 'GET',
                url: `projects`,
                params: {
                    page: params.page ?? 1,
                    limit: params.limit,
                    'filter[is_online]': params.is_online,
                },
            }),
            // @ts-expect-error
            providesTags: ['Projects'],
        }),
    }),
});

type Request = {
    page?: number;
    limit?: number;
    is_online?: boolean;
};

type Response = ListResponse<Project>;

export const { useGetProjectsQuery } = getProjects;
